<template>
  <v-app id="inspire">
    <v-main>
      <ImagemComFallback
        :src="background"
        srcDefault="/assets/imgs/background.svg"
        class="background-image d-flex align-center">
        <v-row class="justify-center">
          <v-col cols="12" sm="8" md="6">
            <v-card class="elevation-12" :color="color">
              <v-col class="d-flex justify-center">
                <v-avatar size="200" max-height="100px" tile>
                  <ImagemComFallback
                    :src="logo"
                    srcDefault="/assets/imgs/logo.svg"
                    height="100%"
                    contain
                  />
                </v-avatar>
              </v-col>
              <v-card-title class="d-flex justify-center pt-0">
                <h5 class="font-weight-light">Recuperação de Senha</h5>
              </v-card-title>
              <v-card-text>
                <core-form v-show="!msgRecuperacaoSuccess" :submit="recuperarSenha">
                  <v-col cols="12" class="py-0">
                    <input-email required v-if="loginField === 'email'" label="E-mail" v-model="model[loginField]" autofocus placeholder=" " />
                    <input-documento required v-if="loginField === 'documento'" label="CPF/CNPJ" v-model="model[loginField]" autofocus placeholder=" " />
                    <input-text required v-if="loginField === 'username'" label="Usuário" v-model="model[loginField]" autofocus placeholder=" " />
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      type="submit"
                      block
                      color="primary"
                      >Enviar Recuperação de Senha
                    </v-btn>
                  </v-col>
                  <v-col cols="5">
                    <router-link
                      :to="`/partner/${ambiente}`"
                      class="font-weight-medium caption text-decoration-none"
                      >Voltar ao login
                    </router-link>
                  </v-col>
                </core-form>
                <v-col cols="12" v-show="msgRecuperacaoError">
                  <v-alert type="error" class="mt-3" text>
                    {{ msgRecuperacaoError }}
                  </v-alert>
                  <br/>
                </v-col>
                <v-col cols="12" v-show="msgRecuperacaoSuccess">
                  <v-alert type="success" class="mt-3" text>
                    {{ msgRecuperacaoSuccess }}
                  </v-alert>
                  <br/>
                  <router-link
                    :to="`/partner/${ambiente}`"
                    class="font-weight-medium caption text-decoration-none"
                    >Voltar ao login
                  </router-link>
                </v-col>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </ImagemComFallback>
    </v-main>
  </v-app>
</template>
<script>
export default {
  metaInfo: {
    title: 'Recuperação de Senha'
  },
  data () {
    return {
      model: { Login: '', PrimeiroAcesso: false },
      msgRecuperacaoError: '',
      msgRecuperacaoSuccess: '',
      loginField: 'email',
      ambiente: localStorage.ambiente
    }
  },
  methods: {
    recuperarSenha () {
      const th = this
      th.clearMsgs()
      th.$api.Autenticacao.SolicitarLinkSenha(th.model).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          var email = response.email || th.model.email
          th.msgRecuperacaoSuccess = `Recuperação de senha enviado para: ${email}`
        } else {
          th.msgRecuperacaoError = response.message || response.error
        }
      })
    },
    clearMsgs () {
      this.msgRecuperacaoError = ''
      this.msgRecuperacaoSuccess = ''
    },
  },
  computed: {
    color: function () {
      return this.$theme.dark ? '#0000007A' : '#FFFFFFCA'
    },
    logo: function () {
      return this.$theme.logo || 'assets/imgs/logo.svg'
    },
    background: function () {
      return this.$theme.background || 'assets/imgs/background.svg'
    },
  }
}
</script>

<style scoped>
  .background-image {
    background-position: center center;
    background-size: cover;
    height: 100vh;
  }
</style>
